import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { endpointPrincipal } from "../../../../../../../api/endPoints/endpointPrincipal/endpointPrincipal";

interface SelectEmpresasProps {
  name: string;
  control: Control<any>;
  label: string;
  disabled?: boolean;
}

interface Empresa {
  id_empresa: number;
  fantasia: string;
  razao_social: string;
}

export const SelectEmpresas = ({ name, control, label, disabled }: SelectEmpresasProps) => {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);

  const carregarEmpresas = async () => {
    try {
      const { data } = await endpointPrincipal.get("/empresas");
      setEmpresas(data);
    } catch (error) {
      toast.error("Erro ao carregar empresas: " + error);
    }
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  return (
    <FormControl fullWidth sx={{ mb: 3 }}>
      <InputLabel id={`${name}-label`} shrink>
        {label}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            {...field}
            labelId={`${name}-label`}
            label={label}
            size="small"
            notched
            disabled={disabled}
          >
            <MenuItem value="">
              <em>Selecione...</em>
            </MenuItem>
            {empresas.map((empresa) => (
              <MenuItem key={empresa.id_empresa} value={empresa.id_empresa}>
                {empresa.fantasia || empresa.razao_social}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
}; 